/**
 * ErrorPill — danger-tinted strip with optional sienna Retry button.
 *
 * Used for surface-level error states (chat history fetch failed,
 * canvas-state fetch failed, send-message failed). When `onRetry` is
 * omitted, the pill renders as informational only.
 */

import { AlertTriangle } from 'lucide-react';

type ErrorPillProps = {
  message: string;
  onRetry?: () => void;
};

export function ErrorPill({ message, onRetry }: ErrorPillProps) {
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-lg border px-3 py-2 text-xs"
      style={{
        background: 'hsl(var(--kaiva-danger) / 0.10)',
        borderColor: 'hsl(var(--kaiva-danger) / 0.4)',
        color: 'hsl(var(--kaiva-danger))',
      }}
    >
      <AlertTriangle
        className="mt-[1px] h-3.5 w-3.5 flex-shrink-0"
        aria-hidden="true"
      />
      <span className="flex-1 leading-snug">{message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="kv-eyebrow rounded-md px-2 py-[2px] text-[10px] transition hover:opacity-90"
          style={{
            background: 'hsl(var(--teal))',
            color: 'hsl(var(--slate-navy))',
          }}
        >
          Retry
        </button>
      )}
    </div>
  );
}
